import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from 'redux';
import { NoticeList, NoticeDetail } from './components';
import { NoticeActions, NotificationActions } from '../../store';

const style = theme => ({
    root: {
        height: '100%'
    },
    visibleList: {
        height: '100%',
        visibility: 'visible'
    },
    hiddenList: {
        height: '100%',
        visibility: 'hidden'
    }
})

const IdentitySelector = (state) => state.Identity;

const Notice = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const noticeActions = bindActionCreators(NoticeActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { token, userData } = useSelector(IdentitySelector);

    const [modeInfo, setModeInfo] = useState({ mode: 'list', data_date: '', data_title: '', data_content: '' });

    const [listRefresh, setListRefresh] = useState(true);

    const { classes } = props;

    //console.log("role=" + role);

    /**
　　 *
 　　* お知らせ詳細画面表示
 　　*
 　　* @param data 選択された行のデータ
 　　*/
    const showDetail = (data) => {
        setModeInfo({ mode: 'detail', data_date: data.date, data_title: data.title, data_content: data.content })
    }

    /**
　　 *
 　　* お知らせ一覧画面表示
 　　*
 　　* @param data 選択された行のデータ
 　　*/
    const showNoticeList = (data) => {
        setModeInfo({ mode: 'list', data_date: '', data_title: '', data_content: '' })
    }
    
    var listClass = classes.hiddenList;
    if (modeInfo.mode == 'list') {
        listClass = classes.visibleList;
    }

    var content = <div></div>;

    //詳細画面
    if (modeInfo.mode == 'detail') {
        content = <NoticeDetail onCancel={showNoticeList} dataDate={modeInfo.data_date} dataTitle={modeInfo.data_title} dataContent={modeInfo.data_content}  />
    }

    return (
        <div className={classes.root} maxWidth={false}>
            {content}
            <div className={listClass}>
                <NoticeList onDetail={showDetail} refresh={listRefresh} />
            </div>
        </div>
    )
}

export default withStyles(style, { withTheme: true })(Notice);
